import React, { useState } from 'react';

import MainButton from '../../../components/agv-button';
import { Banner, Card } from '../clients-ui';
import { FeatureTree, JsonEditor } from '../feature-tree';

/**
 * Options du client (features_v2). Les features v1 ne sont plus gérées : elles
 * ne sont lues que par les versions du mobile antérieures à 2.5.10.
 */
export default function OptionsStep({
  featuresV2,
  setFeaturesV2,
  defaultFeaturesV2,
  clientsOptions,
  onCopyFromClient,
  isCopying,
}) {
  const [isJsonMode, setIsJsonMode] = useState(false);
  const [sourceClientId, setSourceClientId] = useState('');

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <Card
        title="Partir d’un client existant"
        subtitle="Copie ses options et sa tarification, à ajuster ensuite. Ses données, logo, documents et utilisateurs ne sont pas copiés."
      >
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
          <select
            value={sourceClientId}
            onChange={(event) => setSourceClientId(event.target.value)}
            className="tw-h-8 tw-min-w-[260px] tw-rounded-[5px] tw-border tw-border-solid tw-border-input-border tw-bg-white tw-px-2.5 tw-text-[13px]"
          >
            <option value="">Choisir un client…</option>
            {clientsOptions.map((client) => (
              <option key={client.value} value={client.value}>
                {client.name}
              </option>
            ))}
          </select>
          <MainButton
            variant="secondary"
            text="Copier la configuration"
            disabled={!sourceClientId}
            isLoading={isCopying}
            onClick={() => onCopyFromClient(Number(sourceClientId))}
          />
        </div>
      </Card>

      <Card
        title="Options du client"
        subtitle="Cochez les fonctionnalités à activer. Les réglages d’une option s’affichent quand elle est cochée."
        actions={
          <div className="tw-flex tw-gap-2">
            <MainButton
              variant="secondary"
              text={isJsonMode ? 'Vue par options' : 'Éditeur JSON'}
              onClick={() => setIsJsonMode((previous) => !previous)}
            />
            <MainButton
              variant="secondary"
              text="Valeurs par défaut"
              disabled={!defaultFeaturesV2}
              onClick={() => setFeaturesV2(defaultFeaturesV2)}
            />
          </div>
        }
      >
        {isJsonMode ? (
          <JsonEditor value={featuresV2} onChange={setFeaturesV2} />
        ) : (
          <FeatureTree value={featuresV2} onChange={setFeaturesV2} />
        )}
        <Banner>
          Les options sont transmises dans le jeton de connexion : les
          utilisateurs du client les verront à leur prochaine connexion. Pour un
          client existant, chaque modification est relue (avant / après) puis
          tracée dans l’historique à l’enregistrement.
        </Banner>
      </Card>
    </div>
  );
}
